import {
  GET_USERSETTINGS_SUCCESS,
  GET_USERSETTINGS_FAIL,
} from '@peoplenet/vi-components-ui/src/UserSettings/UserSettingsActionsType';
import service from './CustomerService';

import {
  CUSTOMER_SETTINGS_FAILURE,
  CUSTOMER_SETTINGS_REQUEST,
  CUSTOMER_SETTINGS_SUCCESS,
} from './CustomerActionType';

export const getSettings = () => async (dispatch) => {
  dispatch({ type: CUSTOMER_SETTINGS_REQUEST });

  try {
    const settings = await service.getSettings();
    settings.systemMeasure = 'imperial';

    dispatch({
      type: CUSTOMER_SETTINGS_SUCCESS,
      payload: settings,
    });
    dispatch({
      type: GET_USERSETTINGS_SUCCESS,
      payload: settings,
    });
  } catch (e) {
    dispatch({ type: CUSTOMER_SETTINGS_FAILURE });
    dispatch({ type: GET_USERSETTINGS_FAIL });
  }
};
